export const privacyPolicyBodyEs = `Última actualización: 3 de octubre de 2026

La presente información describe cómo se tratan los datos personales de los usuarios que utilizan el portal en línea de pro20.net para realizar reservas, pedidos, solicitudes de información y los demás servicios disponibles.

## 1. Responsable del tratamiento

El responsable del tratamiento de los datos personales es:

Mada Srl

Nombre comercial: Mada Srl

Domicilio: Via 4 novembre 12 - Cisternino (BR) 72014

NIF / CIF: 02750160745

Correo electrónico: {{email}}

PEC: -

Para cualquier solicitud relativa a la protección de datos personales puede contactar con el responsable en los datos indicados arriba.

Si se ha designado un Delegado de Protección de Datos (DPD), puede contactarlo en:

{{email}}

## 2. Tipos de datos tratados

En el uso del portal pueden recogerse y tratarse, según los servicios utilizados:

- nombre y apellidos;
- dirección de correo electrónico;
- número de teléfono y prefijo;
- información relativa a las reservas;
- número de personas asociadas a la reserva;
- fecha y hora de la reserva;
- información y solicitudes introducidas voluntariamente por el usuario;
- historial de reservas y asistencias;
- información relativa a los pedidos realizados;
- productos y servicios adquiridos;
- información relativa a la entrega o la recogida de los pedidos;
- información relativa a las transacciones y al estado de los pagos;
- posibles códigos promocionales, cupones, puntos o programas de fidelización;
- preferencias y consentimientos expresados por el usuario;
- datos técnicos necesarios para el funcionamiento y la seguridad del portal.

Se ruega al usuario que no incluya en las notas o en las solicitudes libres información innecesaria, en particular datos personales de categorías especiales según el artículo 9 del RGPD, salvo cuando sea estrictamente necesario para gestionar la solicitud.

## 3. Finalidades y bases jurídicas del tratamiento

### 3.1 Reservas

Los datos personales se tratan para:

- recibir y gestionar una solicitud de reserva;
- confirmar, modificar o anular una reserva;
- contactar con el cliente en relación con la reserva;
- gestionar la llegada y la presencia en el restaurante;
- gestionar eventuales solicitudes vinculadas a la reserva.

La base jurídica es la ejecución de un contrato o de medidas precontractuales solicitadas por el interesado conforme al artículo 6, apartado 1, letra b), del RGPD.

## 4. Pedidos, recogida y entrega

Cuando el portal permita realizar pedidos, los datos personales pueden utilizarse para:

- recibir y gestionar el pedido;
- preparar los productos pedidos;
- gestionar la recogida en el local;
- organizar la entrega, en su caso;
- comunicar actualizaciones sobre el estado del pedido;
- gestionar modificaciones, cancelaciones o reembolsos;
- prestar asistencia al cliente.

La base jurídica es la ejecución del contrato o de medidas precontractuales solicitadas por el interesado.

## 5. Pagos

Cuando esté previsto, el portal puede permitir el pago de pedidos, depósitos, señales, servicios u otras cantidades a través de proveedores especializados de servicios de pago.

Los datos necesarios para la transacción pueden comunicarse directamente al proveedor del servicio de pago.

El restaurante y el portal pueden recibir información sobre el resultado de la transacción, por ejemplo:

- pago efectuado;
- pago rechazado;
- autorización de la tarjeta;
- depósito efectuado;
- reembolso;
- identificador de la transacción.

Los datos completos de la tarjeta de pago no se almacenan en el restaurante cuando el pago lo gestiona directamente el proveedor de pago.

La base jurídica es la ejecución del contrato y, cuando proceda, el cumplimiento de una obligación legal.

## 6. Comunicaciones relativas al servicio

Los datos de contacto facilitados por el usuario pueden utilizarse para enviar comunicaciones estrictamente vinculadas al servicio solicitado, por ejemplo:

- confirmación de la reserva;
- solicitud de confirmación;
- modificación o cancelación de la reserva;
- recordatorio de la reserva;
- confirmación del pedido;
- actualización del estado del pedido;
- comunicaciones relativas al pago;
- información necesaria para la correcta ejecución del servicio.

Estas comunicaciones podrán realizarse, según los datos de contacto facilitados y los servicios activados por el restaurante, por correo electrónico, SMS, WhatsApp u otros sistemas de mensajería.

Cuando sean estrictamente necesarias para gestionar el servicio solicitado, estas comunicaciones no constituyen comunicaciones promocionales.

## 7. Marketing y comunicaciones promocionales

Solo con el consentimiento del usuario, los datos de contacto podrán utilizarse para el envío de comunicaciones comerciales y promocionales relativas a:

- ofertas y promociones;
- eventos;
- nuevos menús o productos;
- iniciativas del restaurante;
- cupones y códigos de descuento;
- programas de fidelización;
- comunicaciones comerciales personalizadas.

Las comunicaciones podrán enviarse a través de los canales para los que el usuario haya prestado su consentimiento, como correo electrónico, SMS, WhatsApp u otros medios permitidos por la normativa aplicable.

El consentimiento para fines de marketing es facultativo.

La falta de consentimiento no impide realizar reservas, pedidos o utilizar los demás servicios principales del portal.

El consentimiento puede revocarse en cualquier momento, sin que ello afecte a la licitud de los tratamientos realizados antes de la revocación.

## 8. Elaboración de perfiles y personalización

Solo cuando esté previsto y previo consentimiento cuando lo exija la normativa, el responsable podrá utilizar información relativa a las interacciones del usuario con el restaurante para analizar intereses, hábitos y preferencias.

A título de ejemplo, pueden considerarse informaciones como:

- frecuencia de las reservas;
- historial de pedidos;
- productos adquiridos;
- uso de promociones y cupones;
- participación en programas de fidelización;
- preferencias manifestadas por el usuario;
- interacciones con comunicaciones promocionales.

Esta información puede utilizarse para crear segmentos de clientela y hacer más pertinentes las ofertas, promociones y comunicaciones.

El consentimiento para la elaboración de perfiles, cuando se requiera, es facultativo y puede revocarse en cualquier momento.

La falta de consentimiento no impide utilizar los servicios ordinarios de reserva y pedido.

## 9. Programas de fidelización, promociones y cupones

Cuando el restaurante ofrezca programas de fidelización, promociones, acumulación de puntos o cupones, los datos del usuario pueden tratarse para:

- atribuir puntos o ventajas;
- comprobar los requisitos para obtener una promoción;
- generar cupones;
- comprobar el uso de los cupones;
- gestionar premios y ventajas;
- prevenir usos fraudulentos de las promociones.

Las condiciones específicas del programa o de la promoción pueden regularse en un reglamento propio.

## 10. Automatizaciones

El restaurante puede utilizar sistemas automáticos para gestionar algunas actividades vinculadas a la relación con el cliente.

Por ejemplo, el sistema puede automáticamente:

- enviar un recordatorio antes de una reserva;
- enviar una comunicación después de una visita;
- actualizar el estado de una reserva o de un pedido;
- atribuir puntos o cupones;
- enviar comunicaciones cuando se den determinadas condiciones.

Cuando estas automatizaciones tengan fines promocionales o impliquen elaboración de perfiles, se aplican las bases jurídicas correspondientes y, cuando sea necesario, se solicita previamente el consentimiento del usuario.

## 11. Comunicación de los datos

La comunicación de los datos marcados como obligatorios es necesaria para poder prestar el servicio solicitado.

Por ejemplo, la falta de los datos necesarios para la reserva puede hacer imposible completarla.

La comunicación de los datos y del consentimiento para fines de marketing y elaboración de perfiles es facultativa y no condiciona el acceso a los servicios principales.

## 12. Destinatarios de los datos

Los datos personales pueden ser tratados por personal autorizado por el responsable y por proveedores que prestan servicios necesarios para el funcionamiento de la actividad y de la plataforma.

A título de ejemplo, pueden incluirse:

- proveedores de la plataforma informática;
- proveedores de hosting y de servicios en la nube;
- proveedores de servicios de correo electrónico;
- proveedores de servicios de SMS;
- proveedores de servicios de mensajería;
- proveedores de servicios de pago;
- proveedores de servicios de entrega;
- asesores técnicos, administrativos o fiscales;
- otros sujetos que traten datos por cuenta del responsable.

Cuando lo prevea la normativa, estos sujetos actúan como encargados del tratamiento conforme al artículo 28 del RGPD.

Los datos también podrán comunicarse a las autoridades competentes cuando lo exija una obligación legal.

## 13. Transferencia de datos fuera del Espacio Económico Europeo

Algunos proveedores tecnológicos utilizados por el responsable podrían tratar datos personales fuera del Espacio Económico Europeo.

En esos casos, el tratamiento y la transferencia se realizarán de conformidad con el RGPD, mediante los instrumentos y garantías aplicables, como decisiones de adecuación o Cláusulas Contractuales Tipo aprobadas por la Comisión Europea, cuando sean necesarias.

## 14. Plazo de conservación

Los datos personales se conservan durante el tiempo necesario para alcanzar las finalidades para las que fueron recogidos y, posteriormente, durante los periodos exigidos por la normativa aplicable.

En particular:

- los datos relativos a reservas y pedidos se conservarán durante el periodo necesario para gestionar la relación con el cliente y las eventuales obligaciones administrativas, contables o legales;
- los datos relativos a las transacciones se conservarán conforme a las obligaciones fiscales y contables aplicables;
- los datos utilizados con fines de marketing se conservarán hasta la revocación del consentimiento o durante el periodo distinto que determine el responsable según los principios de necesidad y proporcionalidad;
- los datos utilizados para la elaboración de perfiles se conservarán durante el periodo definido por el responsable en relación con las finalidades perseguidas y después se suprimirán o anonimizarán.

Los plazos concretos de conservación adoptados por el responsable pueden solicitarse en los datos de contacto indicados en esta información.

## 15. Seguridad de los datos

El responsable y los proveedores implicados adoptan medidas técnicas y organizativas adecuadas al riesgo para proteger los datos personales frente a pérdida, destrucción, acceso no autorizado, divulgación, modificación o tratamiento ilícito.

## 16. Derechos del interesado

En los casos previstos por el RGPD, el interesado puede ejercer sus derechos y, en particular, solicitar:

- el acceso a sus datos personales;
- la rectificación de los datos inexactos;
- la supresión de los datos;
- la limitación del tratamiento;
- la portabilidad de los datos;
- la oposición al tratamiento;
- la revocación del consentimiento prestado anteriormente.

La revocación del consentimiento no afecta a la licitud del tratamiento efectuado antes de la revocación.

Las solicitudes pueden enviarse a:

{{email}}

El interesado también tiene derecho a presentar una reclamación ante la Autoridad de Protección de Datos italiana (Garante per la protezione dei dati personali) según las modalidades previstas por la normativa vigente.

## 17. Cookies y tecnologías similares

El portal puede utilizar cookies y otras tecnologías necesarias para su funcionamiento.

El eventual uso de cookies analíticas, de elaboración de perfiles o de terceros se rige por la Cookie Policy específica disponible en el portal y, cuando sea necesario, a través del sistema de gestión del consentimiento.

## 18. Modificaciones de la presente información

El responsable puede actualizar periódicamente esta información para adaptarla a cambios normativos, técnicos o de los servicios ofrecidos.

La versión actualizada se pondrá a disposición a través del portal.

Última actualización: 03 de octubre de 2026`;
